<template>
    <div class="bid_w_con">
        <span class="bid_title">프로젝트 정보를 확인해주세요. </span><br>
        <div class="confirm_project">
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>카테고리 : </span>
                <span class="confirm_text">{{result.category.popcon_category}}</span>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>지역 : </span>
                <span class="confirm_text">{{result.category.local }}</span>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>프로젝트 소개 : </span>
                <span class="confirm_text">{{ result.content.title }}</span>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>프로젝트 내용 : </span>
                <p class="confirm_text" style="margin-left: 30px;margin-top:10px;">{{ result.content.content }} </p>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>첨부파일 : </span>
                <span class="confirm_text">{{result.content.file}}</span>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>예산 : </span>
                <span class="confirm_text">{{result.range.finance_range}}</span>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>프로젝트 기간 : </span>
                <span class="confirm_text">{{result.range.period_range}}</span>
            </div>
            <div class="confirm_item">
                <span class="confirm_title"><span><img class="confirm_img" src="/static/images/check.png" ></span>의뢰 마감일 : </span>
                <span class="confirm_text">{{ result.range.end_at }}</span>
            </div>
        </div>
        <div style="clear:both">           
            <div class="next" v-on:click="nextStep">제출하기</div>                    
        </div> 
    </div>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
    props:["result"],
    methods:{       
        prevStep(){EventBus.$emit("bidding_prev")},
        nextStep(){EventBus.$emit("bidding_next")},
    },
    mounted(){       
    },
}
</script>
<style scoped lang="scss">
.bid_w_con{
    padding: 25px 50px;    
    .bid_title{
        font-size: 25px;
        font-weight: bold;
        color: #373737;
        line-height: 1;
        margin-bottom: 15px;
        margin-top: 15px;
        display: inline-block;
    }
    .bidding_seg_con{
        margin-top: 15px;
        border-top: 1px solid #e9e9e9;
        width: 700px;
        margin-left:50px;
        .bidding_finance_item,.bidding_period_item{
            display: list-item;
            color: #454545;
            cursor: pointer;
            width: 50%;
            box-sizing: border-box;
            float: left;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            font-size: 15px;
            text-align: left;       
            height: 55px;
            line-height: 55px;
            padding-left: 30px;
        }
        .bidding_finance_item:hover, .on , .bidding_period_item:hover, {
            background: #f27823;
            color: #fff;
        }
        .bidding_finance_item:nth-child(2n-1) , .bidding_period_item:nth-child(2n-1){
            border-left: 1px solid #e9e9e9;
        }        
    }
    .confirm_project{
        padding: 20px;
        padding-left: 30px;
    }
    .confirm_title{
        font-size: 14px;
        color:#373737;

    }
    .confirm_text{
        font-size: 14px;
        color: #121;
        font-weight: bold;
    }
    .confirm_item{
        border-bottom:1px solid #efefef;
        padding-bottom: 20px;
        padding-top: 20px;
    }
    .confirm_img{
        width: 20px;
        margin-right: 10px;
        margin-top: -5px;
    }
}
#datepicker1{
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    padding: 3px 10px;
    width: 120px;
    margin-left: 30px;    
}
  .prev{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: left;
        margin:30px;
        cursor: pointer;
    }
    .next{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: right;
        margin: 30px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/SPA/Components/Bidding/BiddingComplete.vue